import { defineComponent as f, createElementBlock as a, openBlock as i, mergeProps as m, unref as o, createCommentVNode as r, renderSlot as l, normalizeClass as u, createVNode as g } from "vue";
import { useBindCx as b } from "@scalar/use-hooks/useBindCx";
import { variants as v } from "./variants.js";
import y from "../ScalarLoading/ScalarLoading.vue.js";
const h = ["aria-disabled", "type"], c = {
  key: 3,
  class: "centered"
}, $ = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ScalarButton",
  props: {
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !1 },
    loading: {},
    size: { default: "md" },
    variant: { default: "solid" },
    type: { default: "button" }
  },
  setup(k) {
    const { cx: p } = b();
    return (e, B) => {
      var s, d, n, t;
      return i(), a("button", m(
        {
          "aria-disabled": e.disabled || void 0,
          type: e.type
        },
        o(p)(o(v)({ fullWidth: e.fullWidth, disabled: e.disabled, size: e.size, variant: e.variant }), {
          relative: (s = e.loading) == null ? void 0 : s.isLoading
        })
      ), [
        e.$slots.icon ? (i(), a("div", {
          key: 0,
          class: u(["mr-2 h-4 w-4", { invisible: (d = e.loading) == null ? void 0 : d.isLoading }])
        }, [
          l(e.$slots, "icon")
        ], 2)) : r("", !0),
        e.loading ? (i(), a("span", {
          key: 1,
          class: u({ invisible: (n = e.loading) == null ? void 0 : n.isLoading })
        }, [
          l(e.$slots, "default")
        ], 2)) : l(e.$slots, "default", { key: 2 }),
        (t = e.loading) != null && t.isLoading ? (i(), a("div", c, [
          g(o(y), {
            loadingState: e.loading,
            size: "xl"
          }, null, 8, ["loadingState"])
        ])) : r("", !0)
      ], 16, h);
    };
  }
});
export {
  $ as default
};
